module.exports = __webpack_public_path__ + "img/icon-round-none.41156ccc.png";